import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="posthog-identify"
export default class extends Controller {
  static values = {
    userId: String,
    userRole: String,
    userEmail: String,
    employerName: String,
    trackPageView: { type: Boolean, default: true },
  }

  declare userIdValue: string
  declare userEmailValue: string
  declare userRoleValue: string
  declare employerNameValue: string
  declare trackPageViewValue: boolean

  connect (): void {
    if (window.posthog?.__loaded && this.userIdValue) {
      window.posthog.identify(this.userIdValue, {
        role: this.userRoleValue,
        email: this.userEmailValue,
        employer: this.employerNameValue,
      })
    }

    if (window.segment) {
      // Only identify when we have a user ID.
      if (this.userIdValue) {
        // The frontend Segment Identify call is very basic, because it's currently only
        // responsible for linking any previously created frontend Segment anonymous ID
        // with the user ID. All other traits are sent in backend `identify` calls which
        // are more reliable.
        //
        // TODO: Fetch any UTM parameters in the URL and send those along here too.
        window.segment.identify(this.userIdValue)
      }

      // Only track the page view if specified by the Rails layout/view. For
      // example, views serving a React app with client-side routing will want
      // to delegate page tracking to the React app.
      if (this.trackPageViewValue) {
        window.segment.page('', 'app_frontend_page')
      }
    }
  }
}
